import {useOverallInfo} from '@components/_context/UserOverallInfo';
import {AuthApplication} from '@application/Auth';

export const useFirstSession = (): boolean => {
  const {hasAnyOrders} = useOverallInfo();
  // important to keep isFirstSession evaluation first to avoid hasAnyOrders flickening
  return AuthApplication.isFirstSession() && !hasAnyOrders;
};
